// extracted by mini-css-extract-plugin
module.exports = {"stylesButton":"pTM_uR78","stylesXsButton":"ChYsk_YY"};